/**
 * @订单部分
 * 2022-08-12 kadiam
*/
// import bossApi from '../utils/bossApi'
import bossXypq from '../utils/bossXypq'
import bossWholesale from '../utils/wholesaleRequest'
// import { orderPay } from '@/api/order'
import { getJSSDKSign, orderPay } from '@/api/public'
import router from './../router'
const wx = require('jweixin-module')
// 确认订单
export function confirmOrder(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/confirmOrder', method: 'POST', data })
}
// 确认订单收货地址
export function getConfirmOrderAddress(data) {
  return bossWholesale({ url: 'wholesale/api/apiUserReceiptAddress/getConfirmOrderAddress', method: 'POST', data })
}
// 提交订单
export function submitOrder(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/submitOrder', method: 'POST', data })
}

// 订单详情
export function confirmOrderDetail(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/detail', method: 'POST', data })
}

// 商品搜索 热门搜索
export function mallOrder_confirmOrderUnion(data) {
  return bossXypq({ url: 'hx.baoxian/mallOrder/confirmOrderUnion', method: 'POST', data })
}
// 账期计算
export function quoteStaging_calcQuoteStagingResDto(data) {
  return bossXypq({ url: 'hx.baoxian/quoteStaging/calcQuoteStagingResDto', method: 'POST', data })
}
// 确认账期
export function quoteStaging_confirmQuoteStagingResDto(data) {
  return bossXypq({ url: 'hx.baoxian/quoteStaging/confirmQuoteStagingResDto', method: 'POST', data })
}
// 用户订单列表
export function mallOrder_buyer_list(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/list', method: 'POST', data })
}
// 用户订单列表 - 退款 售后
export function mallOrder_buyer_refundList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/refundList', method: 'POST', data })
}
// 用户订单列表数量
export function mallOrder_buyer_listCount(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/listCount', method: 'POST', data })
}

// 用户订单详情
export function mallOrder_buyer_detail(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/detail', method: 'POST', data })
}
// 用户订单商品列表详情
export function mallOrder_buyer_detail_product(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/detail/product', method: 'POST', data })
}
// 修改订单收货地址
export function mallOrder_updateReceipt(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/updateReceipt', method: 'POST', data })
}
// 用户订单包裹列表
export function mallOrder_orderExpressList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/orderExpressList', method: 'POST', data })
}
// 用户订单包裹商品列表
export function mallOrder_orderExpressProductList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/orderExpressProductList', method: 'POST', data })
}
// 订单使用的优惠活动
export function promotionActivity_usedByOrder(data) {
  return bossXypq({ url: 'hx.baoxian/promotionActivity/usedByOrder?orderId=' + data, method: 'GET' })
}

// 变换支付类型 为 转账支付
export function bankTransferInfo(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/bankTransfer', method: 'POST', data })
}
// 对公转账信息
export function bankInfo(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/notes', method: 'POST', data })
}
// 再来一单
export function copyOrder(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/copyOrder', method: 'POST', data })
}
// 对已转账付款确认
export function bankTransferFinish(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/bankTransferFinish', method: 'POST', data })
}
function WXPayStudy(order, info, success, fail) {
  const current_url = location.href.split('#')[0]
  console.log(current_url)
  getJSSDKSign({ appId: process.env.VUE_APP_BASE_APPID, url: current_url }).then(sign => {
    const payinfo = sign.data
    console.log('wx.config', info)
    payinfo['jsApiList'] = ['chooseWXPay']
    wx.config(payinfo)
    console.log('wx.config', payinfo)

    wx.ready(function () {
      console.log('wx.config--002')
      wx.chooseWXPay({
        timestamp: info.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: info.nonceStr, // 支付签名随机串，不长于 32 位
        package: info.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: info.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: info.paySign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          console.log('wx.chooseWXPay success', res)
          router.replace('/order/payResult?orderId=' + order.orderId + '&status=0&onlinePayType=1')
          success(res)
        },
        cancel: function (err) {
          console.log('wx.chooseWXPay fail', err)
          router.replace('/order/payResult?orderId=' + order.orderId + '&status=1&onlinePayType=1')
          fail(err)
        },
        fail: function (err) {
          console.log('wx.chooseWXPay fail', err)
          router.replace('/order/payResult?orderId=' + order.orderId + '&status=1&onlinePayType=1')
          fail(err)
        }
      })
    })
  })
}
// 支付
export function payStudy(item, type, wayCode, success, fail) { // 1微信支付 2支付宝支付
  orderPay({ orderId: item.orderId, wayCode: wayCode, onlinePayType: parseInt(type) === 1 ? 1 : 2 }).then(res => {
    if (parseInt(type) === 1) {
      console.log('orderPay', res.data)
      var result = res.data.payData; WXPayStudy(item, result, success, fail)
    }
    if (parseInt(type) === 2) {
      if (sessionStorage.getItem('userAgent_sysType') === 'ios') { window.location.replace(res.data.payData) } else { router.push('/order/payCopy?url=' + res.data.payData) }
    }
  }).catch(() => { if (parseInt(type) === 2) { router.push('/order/payResult?orderId=' + item.orderId + '&status=6&onlinePayType=2') } })
}

// 退款原因
export function refund_reason(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleFrontRefund/reason', method: 'GET' })
}

// 分销商城前台退款-新增退款
export function refund_add(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleFrontRefund/add', method: 'POST', data })
}

// 分销商城前台退款-订单商品列表
export function progressingProductRefund(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleFrontRefund/progressingProductRefund?orderId=' + data, method: 'GET' })
}

// 货单详情
export function apiWholesaleShopinglist_detail(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleShopinglist/detail', method: 'POST', data })
}
// 货单详情商品列表
export function apiWholesaleShopinglist_detailProductList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleShopinglist/detailProductList', method: 'POST', data })
}
// 订单退款明细
export function refund_listDetail(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleFrontRefund/list?orderId=' + data, method: 'GET' })
}
// 订单退款明细
export function apiWholesaleOrder_offOrder(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleOrder/offOrder', method: 'POST', data })
}
